var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{staticClass:"button formElement_control_input",class:{ primary: _vm.primary },attrs:{"disabled":_vm.disabled,"type":"submit"},domProps:{"value":_vm.title},on:{"click":function($event){return _vm.click()}}})}
var staticRenderFns = []

export { render, staticRenderFns }